import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DictionaryInterface } from '../data';
import { DictionaryProvider } from '../providers/dictionary.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetDictionaryUseCase implements UseCase<Observable<Transaction<DictionaryInterface[]>>> {
    constructor(private dictionaryProvider: DictionaryProvider) {}

    bind(): Observable<Transaction<DictionaryInterface[]>> {
        return this.dictionaryProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (dictionaries) => Transaction.success(cloneDeep(dictionaries)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
